import { render, staticRenderFns } from "./regular-edm-list.vue?vue&type=template&id=b2e9b3b2&scoped=true&"
import script from "./regular-edm-list.vue?vue&type=script&lang=js&"
export * from "./regular-edm-list.vue?vue&type=script&lang=js&"
import style0 from "./regular-edm-list.vue?vue&type=style&index=0&id=b2e9b3b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2e9b3b2",
  null
  
)

export default component.exports